import React, { useState } from "react";
import {
    Box,
    Heading,
    Text,
    VStack,
    Button,
    useColorModeValue,
    chakra,
    useToast,
} from "@chakra-ui/react";

import { Header as Nav } from "../header/Header";
import { Footer } from "../footer/Footer";
import { useNavigate, useParams } from "react-router-dom";
import { ROUTE_LOGIN, ROUTE_MAIN, ROUTE_PROFILE } from "../../App";
import { ScreenContainer } from "../container/ScreenContainer";
import RegistrationFinishDataProvider from "../dataProviderEvo/registration-finish-data-provider";

export const RegistrationConfirmation = () => {
    const navigate = useNavigate();
    const toast = useToast();

    const [isLoading, setIsLoading] = useState(true);
    const [isActivated, setIsActivated] = useState(false);

    const { poid } = useParams();

    if (poid) {
        const dp = new RegistrationFinishDataProvider();

        if (isLoading) {
            dp.finishRegistration(poid).then((res) => {
                setIsLoading(false);

                if (res.status === "OK") {
                    setIsActivated(true);

                    toast({
                        description: "Potvrzení proběhlo úspěšně",
                        status: "success",
                        duration: 5000,
                        isClosable: true,
                        position: "top"
                    });
                } else {
                    toast({
                        title: "Potvrzení se nezdařilo",
                        description: res.errors[0],
                        status: "error",
                        duration: 5000,
                        isClosable: true,
                        position: "top"
                    });
                }
            });
        }
    } else {
        navigate(ROUTE_MAIN);
        toast({
            description: "Stránka, kterou hledáte, neexistuje, nebo k ní nemáte přístup.",
            status: "info",
            duration: 3000,
            isClosable: true,
            position: "top",
        });
    }

    return (
        <Box
            bg={useColorModeValue("#f9f9f9", "#1a202c")}
            height="100vh"
            display="flex"
            flexDirection="column"
        >
            <Nav />
            <Box flex="1">
                <ScreenContainer pb={"350px"}>
                    <chakra.h1
                        textAlign={"center"}
                        fontSize={"4xl"}
                        py={10}
                        fontWeight={"bold"}
                    >
                        {"Aktivace účtu"}
                    </chakra.h1>

                    <Box
                        width="100%"
                        maxW="800px"
                        mx="auto"
                        bg="white"
                        borderRadius="lg"
                        padding={10}
                        boxShadow="md"
                    >
                        {!isLoading && isActivated && (
                            <VStack spacing={6} textAlign="center">
                                <Heading as="h2" fontSize="2xl" color="green.500">
                                    {"Děkujeme za aktivaci vašeho účtu."}
                                </Heading>
                                <Button
                                    size="md"
                                    colorScheme="pink"
                                    onClick={() => navigate(ROUTE_MAIN + ROUTE_LOGIN)}
                                >
                                    {"Přihlásit se"}
                                </Button>
                            </VStack>
                        )}
                        {!isLoading && !isActivated && (
                            <VStack spacing={6} textAlign="center">
                                <Heading as="h2" fontSize="2xl">
                                    {"Potvrzení účtu se nezdařilo nebo účet již byl aktivován."}
                                </Heading>
                                <VStack flexDirection={"row"}>
                                    <Button
                                        size="md"
                                        colorScheme="pink"
                                        onClick={() => navigate(ROUTE_MAIN + ROUTE_LOGIN)}
                                    >
                                        {"Přihlásit se"}
                                    </Button>
                                    <Button
                                        size="md"
                                        colorScheme="pink"
                                        onClick={() => navigate(ROUTE_MAIN)}
                                    >
                                        {"Hlavní stránka"}
                                    </Button>
                                </VStack>
                            </VStack>
                        )}
                    </Box>
                </ScreenContainer>
            </Box>
            <Footer />
        </Box>
    );
};